const registerPaperConstants = {
  tableSize: 50,
};

export default registerPaperConstants;
